export const validationNames = {
  required: 'required',
  email: 'email',
  website: 'website',
  telephoneNumber: 'telephoneNumber',
};

export const formValidations = {
  [validationNames.required]: {
    message: 'formError.required',
    validation: value => !!value,
  },
  [validationNames.email]: {
    message: 'formError.email',
    validation: value => {
      /*
       * Taken from https://emailregex.com/
       */
      const emailRegex = RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );

      return emailRegex.test(value);
    },
  },
  [validationNames.website]: {
    message: 'formError.website',
    validation: value => {
      const websiteRegex = RegExp(
        /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
      );

      return websiteRegex.test(value);
    },
  },
  [validationNames.telephoneNumber]: {
    message: 'formError.telephoneNumber',
    validation: value => {
      const telephoneNumber = RegExp(
        /^(\+?\d{1,2}\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/,
      );

      return telephoneNumber.test(value);
    },
  },
};

/**
 * Validates an input value using one or many validation functions
 *
 * @param {String} input the input's value
 * @param {Array} validationsArray Array of validation names, must be existing validations
 * name inside the validations array
 */
export const validate = (input, validationsArray = []) => {
  const value = typeof input === 'string' ? input.trim() : input;
  // If the field is empty and it is not required, accept it as valid
  if (value === '' && !validationsArray.includes(validationNames.required)) {
    return { isValid: true };
  }

  const firstValidationToFail = validationsArray.find(
    validation => !formValidations[validation].validation(value),
  );

  return firstValidationToFail
    ? {
        isValid: false,
        message: formValidations[firstValidationToFail].message,
      }
    : { isValid: true };
};
